<template>
  <div class="scrollbar_container sidebar-container" :class="sidebarClass">
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :default-active="defaultActive"
        :collapse="isCollapse"
        :unique-opened="true"
        :collapse-transition="false"
        mode="vertical"
        router
      >

      <template  v-for="routes in pureMenuData">
        <sidebar-item         
          :key="routes.path"
          :item="routes"
          :base-path="routes.path"
          v-if="routes.meta.showLink"
        >
          <template #default="scope">
            <slot name="icon" v-bind="scope"></slot>
          </template>
        </sidebar-item>
      </template>
      
      </el-menu>
    </el-scrollbar>
    <div class="collapse_container">
      <Hamburger
        :is-active="isCollapse"
        id="hamburger-container"
        class="hamburger-container"
        @toggleClick="toggleSidebar"
      />
    </div>
  </div>
</template>
<script setup>
import { computed, ref, reactive, onBeforeMount } from "vue";
import Hamburger from "./Hamburger.vue";
import SidebarItem from "./SidebarItem.vue";
import useMenu from "./useMenu";

/**
 * 显示叶子节点，即不再递归；菜单存在一个alwaysShow属性，菜单总是显示，强制菜单进行递归部分（在递归部分显示alwaysshow这一级title）
 *
 * 菜单分为几种情况
 * 菜单为[]、null、undefined时 不显示任何菜单
 *
 * 菜单只存在一级菜单时，一级菜单的children可能为
 * []、null、undefined，此时菜单显示一级菜单，同时也是叶子节点
 * [{hidden:true,...rest}] 此时菜单仍显示一级菜单（由于要显示一级菜单，且在叶子节点显示，
 * onlyOneChild被赋值为一级菜单，因为对一级菜单的children过滤后，（parent）没有进行赋值操作，故此处需要增加noShowingChildren判断，此时children的长度仍大于0）
 *
 * 菜单存在二级菜单，无三级菜单时，一级菜单的children可能为
 * 一个 存储二级菜单，此时二级菜单的children可能为
 *      []、null、undefined，此时菜单只显示二级菜单，同时也是叶子节点（需要判断onlyOneChild.children?.length，否则这里空数组也会导致显示一级菜单）
 * 多个 直接进入递归部分，循环一级菜单children,进入子组件，菜单无三级菜单，每个二级菜单都是叶子节点
 *
 */
const props = defineProps({
  menuData: {
    type: Object,
    default: () => [],
  },
});
const emit = defineEmits(["sidebarClass"]);
const pureMenuData = computed(()=>{
  return props.menuData.filter((item) => !item.hidden)
})

const { sidebarClass, isCollapse, defaultActive, toggleSidebar } =
  useMenu(props.menuData, emit);
</script>
<style lang="scss" scoped>
.scrollbar_container {
  height: 100%;
  border-top: 1px solid #ddd;
  display: flex;
  flex-direction: column;
  .el-menu {
    border: none;
    user-select: none;
  }
  .el-scrollbar {
    flex: 1;
  }
  .collapse_container {
    // 底部空间 + 底部padding
    height: 36px + 15px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    border-top: 1px solid #ddd;
  }
}
.hideSidebar {
  .collapse_container {
    justify-content: center;
  }
  :deep(.el-menu-tooltip__trigger) {
    justify-content: center;
  }
  :deep(.svg_icon) {
    margin-right: 0 !important;
  }
}
</style>
<style lang="scss" scoped>
@import "sidebar.scss";
</style>
<!-- 此处为全局样式，popup出现在body内（若出现在menu内会被遮挡隐藏） -->
<style lang="scss">
.el-menu--vertical {
  > .el-menu--popup {
    max-height: 100vh;
    overflow-y: auto;

    &::-webkit-scrollbar-track-piece {
      background: #d3dce6;
    }

    &::-webkit-scrollbar {
      width: 6px;
    }

    &::-webkit-scrollbar-thumb {
      background: #99a9bf;
      border-radius: 20px;
    }
  }
}
</style>
